import { getRestaurantRebate } from '../graphql/queries';
import { requestRestaurantRebatePayout, sendMarketingFeeEnquiry } from '../graphql/mutations';
import { makeApiAction } from './actions';
import { devLog } from '../utils';

export const fetchRestaurantRebateAction = (restId) => (dispatch) => {
  const action = 'FETCH_RESTAURANT_REBATE';

  // Don't fetch if restId is invalid
  if (!restId) {
    devLog('warning', 'fetchRestaurantRebateAction: restId is missing', { restId });
    return;
  }

  devLog('info', 'fetchRestaurantRebateAction called', { restId });

  dispatch(
    makeApiAction(
      action,
      getRestaurantRebate,
      { restId },
      null,
      'getRestaurantRebate',
      false, // includeRestId - we're already providing restId explicitly
    ),
  );
};

export const requestRestaurantRebatePayoutAction = (restId, requestedAmount) => (dispatch) => {
  const action = 'REQUEST_RESTAURANT_REBATE_PAYOUT';

  // Don't proceed if restId or requestedAmount is invalid
  if (!restId) {
    devLog('warning', 'requestRestaurantRebatePayoutAction: restId is missing', { restId });
    return;
  }

  // Convert to number if it's a string, or use as-is if it's already a number
  const amountAsNumber =
    typeof requestedAmount === 'string'
      ? parseFloat(requestedAmount)
      : typeof requestedAmount === 'number'
        ? requestedAmount
        : parseFloat(requestedAmount);

  if (!amountAsNumber || isNaN(amountAsNumber) || amountAsNumber <= 0) {
    devLog('warning', 'requestRestaurantRebatePayoutAction: requestedAmount is invalid', {
      requestedAmount,
      amountAsNumber,
    });
    return;
  }

  devLog('info', 'requestRestaurantRebatePayoutAction called', {
    restId,
    requestedAmount,
    amountAsNumber,
    type: typeof amountAsNumber,
  });

  dispatch(
    makeApiAction(
      action,
      requestRestaurantRebatePayout,
      { restId, requestedAmount: amountAsNumber },
      null,
      'requestRestaurantRebatePayout',
      false,
    ),
  );
};

export const clearRequestRestaurantRebatePayoutAction = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_REQUEST_RESTAURANT_REBATE_PAYOUT',
  });
};

export const sendMarketingFeeEnquiryAction = (restId, onCompletion) => async (dispatch) => {
  const action = 'SEND_MARKETING_FEE_ENQUIRY';

  // Don't proceed if restId is invalid
  if (!restId) {
    devLog('warning', 'sendMarketingFeeEnquiryAction: restId is missing', { restId });
    return;
  }

  devLog('info', 'sendMarketingFeeEnquiryAction called', { restId });

  await dispatch(
    makeApiAction(
      action,
      sendMarketingFeeEnquiry,
      { restId },
      null,
      'sendMarketingFeeEnquiry',
      false,
      dispatch,
      null, // handled success manage within component
      {},
      false,
      'Unable to send marketing fee enquiry.',
      false,
      onCompletion,
    ),
  );
};
